module.exports = __webpack_public_path__ + "img/制御工学6_6_3.8d23a0f5.png";